module.exports = __webpack_public_path__ + "static/media/pool.4e6a00c5.jpg";